import { DEFAULT_ARMENIA_BBOX, buildAddressFromGeocode, formatAddressLabel, getYandexLangCode } from '@/utils/addressFormatting';

const suggestApiKey = process.env.APP_YANDEX_SUGGEST_API_KEY;
const geocodeApiKey = process.env.APP_YANDEX_GEOCODE_API_KEY;

export { DEFAULT_ARMENIA_BBOX, buildAddressFromGeocode, formatAddressLabel, formatAddressSubtitle, formatAddressTitle, getYandexLangCode } from '@/utils/addressFormatting';

export const normalizeBranchText = (value) => {
	if (!value || typeof value !== 'object') return value;
	return value.en || value.name || value.hy || value.ru || Object.values(value).find(Boolean) || '';
};

export const formatBranchHours = (value) => {
	if (!value) return '';
	const [hours, minutes] = value.split(':');
	if (!hours || !minutes) return value;
	return `${hours}:${minutes}`;
};

export const fetchAddressSuggestions = async ({ text, lang, bbox = DEFAULT_ARMENIA_BBOX, sessionToken, signal }) => {
	if (!text?.trim() || !suggestApiKey) return [];

	const yandexLang = getYandexLangCode(lang);
	const res = await fetch(`https://suggest-maps.yandex.ru/v1/suggest?apikey=${suggestApiKey}&text=${encodeURIComponent(text)}&lang=${yandexLang}&print_address=1&attrs=uri&bbox=${bbox}&sessiontoken=${sessionToken}&types=street,house&strict_bounds=1`, { signal });
	const data = await res.json();
	return data?.results || [];
};

export const getCoordinatesFromGeocode = async ({ geocode, uri, bbox = DEFAULT_ARMENIA_BBOX, lang }) => {
	const params = new URLSearchParams({
		apikey: geocodeApiKey,
		geocode,
		format: 'json',
		bbox,
		results: '1',
	});
	if (uri) params.set('uri', uri);
	if (lang) params.set('lang', getYandexLangCode(lang));

	const res = await fetch(`https://geocode-maps.yandex.ru/v1/?${params}`);
	const data = await res.json();
	const geoObj = data?.response?.GeoObjectCollection?.featureMember?.[0]?.GeoObject;
	if (!geoObj?.Point?.pos) return null;

	const [lon, lat] = geoObj.Point.pos.split(' ');
	return {
		lat: parseFloat(lat),
		lon: parseFloat(lon),
		geoObj,
	};
};

export const resolveGeocodePrefill = async (coords, lang) => {
	const yandexLang = getYandexLangCode(lang);
	const res = await fetch(`https://geocode-maps.yandex.ru/v1/?apikey=${geocodeApiKey}&geocode=${coords.longitude},${coords.latitude}&format=json&lang=${yandexLang}&results=1`);
	const data = await res.json();
	const geoObj = data?.response?.GeoObjectCollection?.featureMember?.[0]?.GeoObject;
	if (!geoObj) return {};

	return {
		address: buildAddressFromGeocode(geoObj),
		geo_coords: { lat: coords.latitude, lon: coords.longitude },
	};
};

export const resolveSuggestionPrefill = async (suggestion, bbox = DEFAULT_ARMENIA_BBOX) => {
	const address = suggestion?.title?.text || suggestion?.address?.formatted_address || '';

	try {
		const result = await getCoordinatesFromGeocode({
			uri: suggestion.uri,
			geocode: suggestion.address.formatted_address,
			bbox,
		});

		if (!result) return { address };

		return {
			address: result.geoObj ? buildAddressFromGeocode(result.geoObj) : address,
			geo_coords: { lat: result.lat, lon: result.lon },
		};
	} catch {
		return { address };
	}
};
